import React from 'react'
import AddItemForm from '../../components/AddItemForm'

export default function AddItem() {
  return (
    <div className="lg:px-20 ">
      <AddItemForm />
    </div>
  )
}
